import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var DiscrepancyInPayoutTotalIA = function DiscrepancyInPayoutTotalIA(_ref) {
  var brandOrder = _ref.brandOrder;
  if (brandOrder) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XAYTV2",
      defaultMessage: [{
        "type": 0,
        "value": "Before contacting our support team, we recommend double-checking your payout, with the following details in mind:"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "meI9PQ",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Review your payout"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": See the full calculation on the "
      }, {
        "children": [{
          "type": 0,
          "value": "Order details page"
        }],
        "type": 8,
        "value": "OrderDetailLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderDetailLinkFormatting: function OrderDetailLinkFormatting(chunks) {
          var _brandOrder$brand_ord, _brandOrder$brand_ord2;
          return orderDetailLinkFormatting(chunks, (_brandOrder$brand_ord = (_brandOrder$brand_ord2 = brandOrder.brand_order) === null || _brandOrder$brand_ord2 === void 0 ? void 0 : _brandOrder$brand_ord2.token) !== null && _brandOrder$brand_ord !== void 0 ? _brandOrder$brand_ord : "");
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "/23Rwc",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Check for returns or adjustments"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": Returns, shipping adjustments or promotional discounts can affect your payout. These are itemised in your transaction details. If any items are marked as damaged or missing, they will be deducted from the payout of the order they originated."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 3
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "d6yt+p",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Consider commissions"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": Commissions are calculated based on the order subtotal."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 4
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lEvLnb",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Account for processing fees"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": Payment-processing fees will affect the final payout amount. The fee structure is aligned with the payout option you’ve selected."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 5
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "GgW3sY",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Contact for clarification"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": If you’ve still got concerns or if something doesn’t seem right with your payout, please don’t hesitate to contact us."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "omcjTV",
    defaultMessage: [{
      "type": 0,
      "value": "Before contacting our support team, we recommend double-checking your payout, with the following details in mind:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IzZ4Mb",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Review your payout"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": See the full calculation for a specific order by going to the Orders and then clicking into the order’s detail page. Scroll to the You got paid! section and select \"View payout summary\". There you will find a detailed breakdown of the payout."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "SWyxt7",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Check for returns or adjustments"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": Returns, shipping adjustments or promotional discounts can affect your payout. These are itemised in your payout summary. If any items are marked as damaged or missing, they will be deducted from the payout of the order they originated."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "OGBrmv",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Consider commissions"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": Commissions are calculated based on the order subtotal."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "mU015p",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Look for processing fees"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": Payment-processing fees will affect the final payout amount. The fee structure is aligned with the payout option you’ve selected."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xUp5Oe",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Contact for clarification"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": If you’ve still got concerns or if something doesn’t seem right with your payout, please don’t hesitate to contact us."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var orderDetailLinkFormatting = function orderDetailLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderFulfilment(brandOrderToken, {
      sync: "true"
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};